import { Link, useSearchParams } from 'react-router-dom';
import { Mail, Clock } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../../components/ui/card';
import { Alert, AlertDescription } from '../../components/ui/alert';

export function WaitlistConfirmation() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || 'your email';

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="mx-auto mb-4 relative">
            <div className="w-20 h-20 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center">
              <Mail className="h-10 w-10 text-blue-600" />
            </div>
            <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          <CardTitle className="text-2xl font-bold text-gray-900">
            You're on the waitlist!
          </CardTitle>

          <CardDescription className="text-base">
            Please check your email to verify your address
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="text-center">
            <p className="text-lg font-semibold text-foreground">
              {email}
            </p>
          </div>

          <Alert className="border-blue-200 bg-blue-50">
            <Mail className="h-4 w-4 text-blue-600" />
            <AlertDescription className="text-blue-800">
              Click the verification link in your email to confirm your spot on the waitlist.
            </AlertDescription>
          </Alert>

          <div className="bg-gray-50 rounded-xl p-4 space-y-3">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-xs font-bold text-blue-600">1</span>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Check your inbox</p>
                <p className="text-xs text-gray-500">Look for an email from AccountsGenie</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-xs font-bold text-blue-600">2</span>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Verify your email</p>
                <p className="text-xs text-gray-500">Click the verification link</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
                <Clock className="h-3 w-3 text-gray-500" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Wait for approval</p>
                <p className="text-xs text-gray-500">We'll email you when your account is ready</p>
              </div>
            </div>
          </div>

          <div className="text-center text-sm text-muted-foreground">
            <p>Check your spam folder if you don't see the email.</p>
          </div>
        </CardContent>

        <CardFooter className="flex flex-col space-y-3">
          <Button
            asChild
            variant="outline"
            className="w-full"
          >
            <Link to="/">
              Return to Homepage
            </Link>
          </Button>
          <p className="text-xs text-center text-muted-foreground">
            Questions?{' '}
            <Link to="/contact" className="text-primary hover:underline">
              Contact Support
            </Link>
          </p>
        </CardFooter>
      </Card>
    </div>
  );
}

export default WaitlistConfirmation;
